window.kUtils = {

    validatePostalCode: function(params, callback) {

        $.get('/khis_util/validate_postal_code', params, null, "json")
            .done(function (data, status, xhr) {
                if (callback) {
                    callback(data);
                }
            })
            .fail(function (xhr, status, error) {
                if (callback) {
                    callback(error, null);
                }
            });
    },

    getSysConfigurationValue: function (code) {

        return $.ajax({
            url: '/khis_util/get_sys_conf',
            dataType: "json",
            type: 'GET',
            data: {code: code},

            success: function (data,st, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
            },
            error: function (data,st, xhr) {
            }
        });

    }
};